module.exports = __webpack_public_path__ + "static/media/venus-double.4984dcef.svg";